"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../helpers/CordovaFileHelper"));

var _FileSystemWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileSystemWrapper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var CACHE = {};

var Image = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Image, _React$Component);

  var _super = _createSuper(Image);

  function Image(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Image);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadImage", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(src) {
        var isSvg, isBrowser, prefix, filename, srcToSet;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!src || src.indexOf('data') === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                isSvg = src.indexOf('.svg') >= 0;
                isBrowser = _DeviceInfoHelper["default"].isBrowser();

                if (!(isSvg || _DeviceInfoHelper["default"].isiOS() || _DeviceInfoHelper["default"].isAndroid())) {
                  _context.next = 42;
                  break;
                }

                if (!isBrowser) {
                  _context.next = 9;
                  break;
                }

                _context.t0 = '';
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return _FileSystemWrapper["default"].getPathPrefix();

              case 11:
                _context.t0 = _context.sent;

              case 12:
                prefix = _context.t0;
                filename = src.replace(prefix, ''); // noinspection UnnecessaryLocalVariableJS

                if (!isBrowser) {
                  _context.next = 18;
                  break;
                }

                _context.t1 = filename;
                _context.next = 39;
                break;

              case 18:
                if (!isSvg) {
                  _context.next = 24;
                  break;
                }

                _context.next = 21;
                return _CordovaFileHelper["default"].readTextFile(filename);

              case 21:
                _context.t2 = _context.sent;
                _context.next = 38;
                break;

              case 24:
                if (!_config["default"].useLocalhostFiles) {
                  _context.next = 30;
                  break;
                }

                _context.next = 27;
                return _this.getCorrectUrl(filename);

              case 27:
                _context.t3 = _context.sent;
                _context.next = 37;
                break;

              case 30:
                _context.t4 = _FileReaderWriterWrapper["default"];
                _context.next = 33;
                return _CordovaFileHelper["default"].getFileEntry(filename);

              case 33:
                _context.t5 = _context.sent;
                _context.next = 36;
                return _context.t4.readFileAsDataUrl.call(_context.t4, _context.t5);

              case 36:
                _context.t3 = _context.sent;

              case 37:
                _context.t2 = _context.t3;

              case 38:
                _context.t1 = _context.t2;

              case 39:
                srcToSet = _context.t1;
                //await FileReaderWriterWrapper.readFileAsDataUrl(await CordovaFileHelper.getFileEntry(filename)))
                CACHE[src] = srcToSet;

                _this.forceUpdate();

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unloadImage", function () {
      if (CACHE[_this.props.src]) {
        delete CACHE[_this.props.src];
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadImage(this.props.src);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!CACHE[newProps.src]) {
        this.loadImage(newProps.src);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {// this.unloadImage()
    }
  }, {
    key: "getCorrectUrl",
    value: function () {
      var _getCorrectUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(filename) {
        var fileEntry, fileSrc, srcToReturn;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _CordovaFileHelper["default"].getFileEntry(filename);

              case 2:
                fileEntry = _context2.sent;
                fileSrc = fileEntry.toURL();
                srcToReturn = _DeviceInfoHelper["default"].isiOS() && window.WkWebView ? window.WkWebView.convertFilePath(fileSrc) : fileSrc;
                return _context2.abrupt("return", srcToReturn);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getCorrectUrl(_x2) {
        return _getCorrectUrl.apply(this, arguments);
      }

      return getCorrectUrl;
    }()
  }, {
    key: "render",
    value: function render() {
      // keep onError here!
      var _this$props = this.props,
          src = _this$props.src,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["src"]);

      if (!src) {
        return null;
      }

      if (src.indexOf('.svg') !== -1 && !_DeviceInfoHelper["default"].isBrowser()) {
        return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
          key: src,
          dangerouslySetInnerHTML: {
            __html: CACHE[src]
          }
        }, props));
      } else {
        return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
          key: src,
          onLoad: this.onLoad,
          src: CACHE[src] || src
        }, props));
      }
    }
  }]);
  return Image;
}(_react["default"].Component);

Image.propTypes = {
  src: _propTypes["default"].string // add any property that is supported by <img> tag

};
var _default = Image;
exports["default"] = _default;